import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  TCHSeriesListingDownloadBrochuresDataAssets,
  TCHSeriesListingDownloadBrochuresProps,
  TProductListingDownloadBrochuresBackgroundImage,
} from '../types/productSeriesListingDownloadBrochures.types';
import { StringField } from '../../../types/types';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import { TSitecoreContext } from '../../../types/sitecore.types';

export class CHSeriesListingDownloadBrochureModel {
  /* eslint-disable-next-line */
  private readonly fields: any;
  private readonly rendering?: ComponentRendering;
  private readonly context?: TSitecoreContext;

  constructor(props: TCHSeriesListingDownloadBrochuresProps) {
    this.fields = props?.fields || null;
    this.rendering = props?.rendering;
    this.context = props?.sitecoreContext;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get title(): StringField {
    return { value: this.fields?.apiData?.title || null };
  }

  get eyebrow(): StringField {
    return { value: this.fields?.apiData?.eyebrow || null };
  }

  get description(): StringField {
    return { value: appendRootToRichTextInternalLinks(this.fields?.apiData?.description || null) };
  }

  get downloadBrochureCard(): TCHSeriesListingDownloadBrochuresDataAssets[] {
    return this.fields?.apiData?.items?.map((item) => {
      return {
        ...item,
        icon: this.fields?.itemData?.iconsList || [],
      };
    });
  }

  get canShowComponent(): boolean {
    return Boolean(this.fields?.apiData?.items?.length > 0);
  }

  get desktopImage(): TProductListingDownloadBrochuresBackgroundImage {
    return this.fields?.itemData?.fields?.imageParameters?.desktopImageData;
  }

  get mobileImage(): TProductListingDownloadBrochuresBackgroundImage {
    return this.fields?.itemData?.fields?.imageParameters?.mobileImageData;
  }

  get defaultBgDesktopImage(): TProductListingDownloadBrochuresBackgroundImage | undefined {
    return {
      url: this.context?.defaultBackgroundImageParameters?.desktopImageData?.downloadBrochures,
    };
  }

  get defaultBgMobileImage(): TProductListingDownloadBrochuresBackgroundImage | undefined {
    return {
      url: this.context?.defaultBackgroundImageParameters?.mobileImageData?.downloadBrochures,
    };
  }

  get desktopBgImage(): TProductListingDownloadBrochuresBackgroundImage | undefined {
    return this.desktopImage?.url ? this.desktopImage : this.defaultBgDesktopImage;
  }

  get mobileBgImage(): TProductListingDownloadBrochuresBackgroundImage | undefined {
    return this.mobileImage?.url ? this.mobileImage : this.defaultBgMobileImage;
  }

  get contextItemUrl(): string {
    return this.fields?.itemData?.contextItemUrl || '';
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
